<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">

    <!-- Header -->
    <div class="flex-0 flex flex-row items-center gap-x-4 w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">

        <button (click)="backToBriefs()" type="button" class="btn-fab-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
            </svg>
        </button>

        <div class="flex flex-row items-center justify-between w-full">
            <!-- Stepper -->
            <div class="flex items-center w-full">
                @for (step of briefSteps; track step.id; let isLast = $last) {
                <div class="flex items-center flex-1">
                    <div class="flex items-center">
                        <!-- Step Circle -->
                        <div class="flex flex-row items-center justify-center">
                            <div class="flex flex-row items-center justify-center size-6 rounded-full border-2 transition-colors"
                                [class]="getStepCircleClass(step)">
                                @if (step.status === 1) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="m9 12 2 2 4-4" />
                                </svg>
                                } @else {
                                <span class="text-sm font-semibold">{{ step.id + 1 }}</span>
                                }
                            </div>
                            <span class="ml-2 text-sm font-medium transition-colors" [class]="getStepLabelClass(step)">
                                {{ step.name }}
                            </span>
                        </div>
                        <!-- Step Circle - END-->
                    </div>
                    <!-- Connector Line -->
                    @if (!isLast) {
                    <div class="flex-1 h-0.5 mx-4 transition-colors"
                        [class]="getConnectorClass(step, briefSteps[step.id + 1])">
                    </div>
                    <!-- Connector Line - END-->
                    }
                </div>
                }
            </div>
            <!-- Stepper - END -->
        </div>
    </div>
    <!-- Header - END-->

    <!-- Content -->
    <div class="flex-1 flex flex-col justify-start items-center overflow-hidden w-full">
        <div class="w-full h-full" [@stepSlide]="currentStep()">
            @switch (currentStep()) {
            @case (0) {
            <agent-step-basic-info></agent-step-basic-info>
            }
            @case (1) {
            <agent-step-distribution></agent-step-distribution>
            }
            @case (2) {
            <agent-step-documentation></agent-step-documentation>
            }
            @case (3) {
            <agent-step-creator-profile></agent-step-creator-profile>
            }
            @case (4) {
            <agent-step-compensation></agent-step-compensation>
            }
            }
        </div>
    </div>

    <!-- Footer -->
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
        <div class="flex flex-row items-center gap-x-4">
            @if (currentStep() > 0) {
            <button (click)="previousStep()" type="button"
                class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
                Back</button>
            }
            <!-- <button type="button" class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">Save
                Draft
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path
                        d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
                    <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
                    <path d="M7 3v4a1 1 0 0 0 1 1h7" />
                </svg>
            </button> -->
        </div>

        <button (click)="nextStep()" type="button" class="primary-button inline-flex flex-row items-center gap-x-2">
            @if (isLastStep()) {
            Post Brief
            } @else {
            Continue
            }
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </button>
    </div>
    <!-- Footer - END -->
</div>


@if (showBriefBusyCreating()) {
<atom-loading-overlay></atom-loading-overlay>
}